import { render, staticRenderFns } from "./m-form.vue?vue&type=template&id=0adf6edc&"
import script from "./m-form.vue?vue&type=script&lang=js&"
export * from "./m-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports